import { memo } from 'react'
import { CubeLoader } from '@/components/ui/cube-loader'
import useReviewLaunch from './hooks/useReviewLaunch'
import ReviewAudiencesList from './ReviewAudiencesList'
import CampaignDetailsSection from './CampaignDetailsSection'
import BudgetMoveConfirmation from './BudgetMoveConfirmation'
import AdvantageLeadsReview from './AdvantageLeadsReview'
import { useMediaBuyingContext } from '@/context/media-buying-context'

const ReviewLaunch = memo(({ isAddAudience = false }) => {
    const {
        reviewLaunchData,
        isEditAdSetMode,
        visibleStages,
        availableStages,
        collapsedStages,
        selectedAudience,
        isLoading,
        updateReviewLaunchData,
        getSelectedAudiences,
        getCreativesForAudience,
        toggleStageCollapse,
        areAllStagesCollapsed,
        toggleAllStages,
        handleAudienceSelection,
        handleAudienceNameChange,
        getAudienceDisplayName,
        getAudienceBudget,
        usesCampaignBudget,
        getCampaignObjective,
        getAudienceGenderTargets,
        getAudienceAgeTargets,
        getAudienceDeviceTargets,
        getAudienceLocationData,
        getAudiencePlatformPlacementTargets,
        getAudienceCustomEventType,
        formatTimeLeft,
    } = useReviewLaunch(isAddAudience)

    const mediaBuyingContext = useMediaBuyingContext()
    const { connectedPublishers } = mediaBuyingContext
    const publisher = connectedPublishers ? Object.values(connectedPublishers)[0] : null
    const { currency } = publisher

    if (isLoading) {
        return (
            <div className="tw:flex tw:justify-center tw:items-center tw:py-12">
                <CubeLoader size="default" />
            </div>
        )
    }

    return (
        <div className="tw:min-h-full tw:flex tw:flex-col tw:w-full tw:max-w-full tw:overflow-hidden">
            <div className="tw:flex tw:w-full tw:max-w-full tw:overflow-hidden">
                <div className="tw:pb-16 tw:flex-1 tw:w-full tw:max-w-full tw:overflow-hidden">
                    <CampaignDetailsSection
                        reviewLaunchData={reviewLaunchData}
                        updateReviewLaunchData={updateReviewLaunchData}
                        formatTimeLeft={formatTimeLeft}
                        isAddAudience={isAddAudience}
                        isEditAdSetMode={isEditAdSetMode}
                    />

                    {isAddAudience && <BudgetMoveConfirmation currency={currency} />}
                    {!isAddAudience && <AdvantageLeadsReview currency={currency} />}

                    <ReviewAudiencesList
                        currency={currency}
                        visibleStages={visibleStages}
                        availableStages={availableStages}
                        collapsedStages={collapsedStages}
                        selectedAudience={selectedAudience}
                        getSelectedAudiences={getSelectedAudiences}
                        getCreativesForAudience={getCreativesForAudience}
                        getAudienceDisplayName={getAudienceDisplayName}
                        getAudienceBudget={getAudienceBudget}
                        usesCampaignBudget={usesCampaignBudget()}
                        getCampaignObjective={getCampaignObjective}
                        getAudienceGenderTargets={getAudienceGenderTargets}
                        getAudienceAgeTargets={getAudienceAgeTargets}
                        getAudienceDeviceTargets={getAudienceDeviceTargets}
                        getAudienceLocationData={getAudienceLocationData}
                        getAudiencePlatformPlacementTargets={getAudiencePlatformPlacementTargets}
                        getAudienceCustomEventType={getAudienceCustomEventType}
                        toggleStageCollapse={toggleStageCollapse}
                        toggleAllStages={toggleAllStages}
                        areAllStagesCollapsed={areAllStagesCollapsed}
                        handleAudienceSelection={handleAudienceSelection}
                        handleAudienceNameChange={handleAudienceNameChange}
                    />
                </div>
            </div>
        </div>
    )
})

ReviewLaunch.displayName = 'ReviewLaunch'

export default ReviewLaunch
